import css from "./ReadOnlyBirthdayField.module.scss";
import { format, fromUnixTime } from "date-fns";

type ReadOnlyBirthdayFieldProps = {
  birth_date: number;
};
export const ReadOnlyBirthdayField: React.FC<ReadOnlyBirthdayFieldProps> = ({ birth_date }) => (
  <div className="field">
    <label className={css.label}>
      <span className="label">生まれ年</span>
      <p className="display">{format(fromUnixTime(birth_date), "yyyy年 生まれ")}</p>
    </label>
  </div>
);
